import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=2e448372&"
import script from "./UploadImage.vue?vue&type=script&lang=js&"
export * from "./UploadImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports